import { nanoid } from 'nanoid';
import { useMemo } from 'react';
import { getDownloadUrl, uploadFile } from '../../lib/s3Storage';
import { Engineer } from '../../models/engineer';
import { Maybe } from '../../types';

export default function useResumeAttachment(engineer: Maybe<Engineer>) {
  return useMemo(() => ({
    getDownloadUrl() {
      return engineer?.cv?.key
        ? getDownloadUrl(engineer.cv.key, { level: 'private' })
        : Promise.resolve(null);
    },
    upload(identityId: string, file: File) {
      if (!engineer) return Promise.reject(new Error('No engineer present'));
      return uploadFile(identityId, file, { level: 'private', prefix: `${engineer.owner}--${nanoid(5)}--` });
    },
  }), [engineer]);
}
